/**
 * UrbanismeLayout — shell partagé du module Urbanisme (staff).
 * Jumeau de GrcLayout, accent « urba ». AppHeader + UrbanismeNav sur toutes
 * les pages staff du module (Golden Rule 2 du guide des briques).
 */

import { type ReactNode } from 'react';
import { AppHeader } from '@/components/AppHeader';
import { UrbanismeNav, type UrbanismeNavKey } from '@/components/UrbanismeNav';

export function UrbanismeLayout({
  active,
  children,
}: {
  active: UrbanismeNavKey;
  children: ReactNode;
}) {
  return (
    <div className="min-h-screen text-ink">
      <AppHeader module="Urbanisme" accent="urba" />
      <nav
        aria-label="Sections Urbanisme"
        className="sticky top-[57px] z-50 border-b border-border bg-surface/60 backdrop-blur-glass"
      >
        <div className="px-4 py-2 sm:px-6">
          <UrbanismeNav active={active} />
        </div>
      </nav>
      {children}
    </div>
  );
}
